import cn from 'classnames';
import { FC, ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { Breadcrumbs, Button } from '@/shared/ui';

import { useStorageBlockedTooltip } from '@/entities/organization';

import { useMobileBreadcrumbs } from '@/widgets/Header';

import styles from './DentalPhotosHeader.module.scss';

type DentalPhotosHeaderProps = {
  isStorageBlocked: boolean;
  canUpload: boolean;
  isMobile?: boolean;
  className?: string;
  testID?: string;
  uploadControl?: ReactElement;
  onUploadClick: () => void;
};

export const DentalPhotosHeader: FC<DentalPhotosHeaderProps> = (props) => {
  const {
    canUpload,
    className,
    isMobile = false,
    isStorageBlocked,
    testID,
    uploadControl,
    onUploadClick,
  } = props;
  const { formatMessage } = useIntl();
  const mobileBreadcrumbs = useMobileBreadcrumbs();
  const { wrapWithStorageTooltip } = useStorageBlockedTooltip({
    isStorageBlocked,
  });

  return (
    <header
      data-testid={testID}
      className={cn(styles.container, className)}
      data-component="dental-photos-header"
    >
      {isMobile ? (
        <Breadcrumbs breadCrumbs={mobileBreadcrumbs} isClickable />
      ) : (
        <h3 className={'h3'}>
          {formatMessage({
            id: 'dentalPhotosPage.title',
            defaultMessage: 'Dental photos',
          })}
        </h3>
      )}

      {canUpload &&
        wrapWithStorageTooltip(
          uploadControl ?? (
            <Button
              variant="primary"
              size={isMobile ? 'medium' : undefined}
              disabled={isStorageBlocked}
              onClick={onUploadClick}
            >
              {formatMessage({
                id: 'global.upload',
                defaultMessage: 'Upload',
              })}
            </Button>
          ),
        )}
    </header>
  );
};
